/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Name_FolderInputs */

const en_dialog_name_folder = /** @type {(inputs: Dialog_Name_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name folder`)
};

const es_dialog_name_folder = /** @type {(inputs: Dialog_Name_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la carpeta`)
};

/**
* | output |
* | --- |
* | "Name folder" |
*
* @param {Dialog_Name_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_name_folder = /** @type {((inputs?: Dialog_Name_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Name_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_name_folder(inputs)
	return en_dialog_name_folder(inputs)
});